<template>
  <div id="grid-estados">
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex>
          <div v-if="loading">
            <loading></loading>
          </div>
          <v-data-table
            :headers="headers"
            :items="itemsContingencia"
            :rows-per-page-items="rowsPerPageItems"
            hide-actions
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td class="text-xs-left">{{ props.item.author }}</td>
              <td>{{ props.item.estadoContingencia.descripcion }}</td>
              <td class="text-xs-left">{{ props.item.fechaCreacion }}</td>
              <td class="text-xs-left">{{ props.item.observaciones }}</td>
              <v-btn
                v-if="props.item.tiene_documento == true"
                depressed
                outline
                title="Descargar documento"
                icon
                fab
                dark
                color="primary"
                small
                @click="downloadFile(props.item.id, props.item.filename)"
              >
                <v-icon>cloud_download</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
      <v-dialog v-model="dialogLoading" persistent max-width="390">
        <loading-descarga></loading-descarga>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";

export default {
  name: "grid-estados",
  components: {
    LoadingDescarga,
  },
  props: {
    id: "",
    tipeView: "",
    filename: "",
  },
  data() {
    return {
      dialogLoading: false,
      loading: false,
      dialog: false,
      filename: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      headers: [
        { text: "Autor", sortable: false, value: "author" },
        {
          text: "Estado",
          align: "left",
          sortable: false,
          value: "estadoContingencia",
        },
        { text: "Fecha Inicio", sortable: false, value: "fechaCreacion" },
        { text: "Observaciones", sortable: false, value: "observaciones" },
        { text: "Acción", sortable: false, value: "documento" },
      ],
      itemsContingencia: "",
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 4000);
    },
  },
  mounted() {},
  created() {
    this.contratoId = this.$store.getters.contratoStored;
    this.idUsuario = this.$store.getters.userLogged.id;
    this.loadDataContingencia();
  },
  computed: {},
  methods: {
    async loadDataContingencia() {
      this.loading = true;
      this.itemsContingencia = await this.loadDocumentoData();
      this.loading = false;
    },

    async downloadFile(id, filename) {
      this.dialogLoading = true;
      let that = this;
      return await axios({
        url: "contingencia/download/" + id + "/" + this.contratoId,
        method: "GET",
        responseType: "blob",
      })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    async loadDocumentoData() {
      return await axios
        .get("contingencia/" + this.id + "/estados/" + this.contratoId)
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
          }
        });
    },
  },
};
</script>
